import { digitSeperator } from '@/utils/digitSeperator';
import { Box, Typography } from '@mui/material';

const PlanCardButton = ({ finalPrice, recommended = false }) => {
  return (
    <Box
      sx={{
        borderRadius: 10,
        width: '230px',
        height: '72px',
        bgcolor: recommended ? 'primary.main' : 'secondary.main',
        color: recommended ? 'common.black' : 'common.white',
        boxShadow:
          '0px 2px 4px -2px rgba(22, 34, 51, 0.4), 0px 8px 16px rgba(22, 34, 51, 0.4)',
        '&:hover': {
          bgcolor: recommended ? 'primary.dark' : 'secondary.dark',
          boxShadow:
            '0px 4px 8px -4px rgba(22, 34, 51, 0.08), 0px 16px 24px rgba(22, 34, 51, 0.08)',
        },
        p: 2,
        display: 'grid',
        gridTemplateColumns: finalPrice > 0 ? 'auto 1fr auto' : '1fr',
        gap: 1,
      }}>
      {finalPrice > 0 ? (
        <>
          <Typography>ماهانه</Typography>
          <Typography
            fontSize="1.5em"
            fontWeight={500}
            textAlign="center"
            alignSelf={'flex-end'}>
            {digitSeperator(finalPrice)}
          </Typography>
          <Typography>تومان</Typography>
        </>
      ) : (
        <Typography fontSize={30} textAlign="center">
          رایگان
        </Typography>
      )}
    </Box>
  );
};

export default PlanCardButton;
